import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { app_permissions } from '../../security/app-permissions';
import { PermissionService } from '../../security/permission.service';
import { ExecutionDraftLaunchData, ExecutionSalesOrderSourceType } from './execution-sales-order.model';
import { ExecutionSalesOrderLauncherService } from './execution-sales-order-launcher.service';
import { OrdersService } from '../order.service';

@Component({
  selector: 'app-execution-sales-order-button',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `<ng-container *ngIf="canCreate">
    <button *ngIf="!effectiveOrderId && allowCreate" pButton type="button" icon="pi pi-shopping-cart" label="Create Sales Order Draft"
            [disabled]="disabled || !sourceId || !owningCompanyId" (click)="open()"></button>
    <span *ngIf="effectiveOrderId" class="inline-flex gap-2">
      <button pButton type="button" icon="pi pi-external-link" label="Open Sales Order" (click)="openExisting()"></button>
      <button *ngIf="allowCreate" pButton type="button" icon="pi pi-download" label="Import New Charges" severity="secondary" [outlined]="true"
              [disabled]="disabled" (click)="open(effectiveOrderId)"></button>
    </span>
  </ng-container>`
})
export class ExecutionSalesOrderButtonComponent implements OnChanges {
  @Input({ required: true }) sourceType!: ExecutionSalesOrderSourceType;
  @Input({ required: true }) sourceId!: number | null | undefined;
  @Input({ required: true }) owningCompanyId!: number | null | undefined;
  @Input() sourceLabel?: string;
  @Input() orderId?: number;
  @Input() disabled = false;
  @Input() allowCreate = true;
  detectedOrderId?: number;

  constructor(private launcher: ExecutionSalesOrderLauncherService, private permissions: PermissionService,
              private orders: OrdersService, private router: Router) {}
  get canCreate(): boolean { return this.permissions.hasPermission(app_permissions.order.records.create); }
  get effectiveOrderId(): number | undefined { return this.orderId || this.detectedOrderId; }
  ngOnChanges(): void {
    this.detectedOrderId = undefined;
    if (!this.canCreate || this.orderId || !this.sourceId || !this.owningCompanyId) return;
    this.orders.previewExecutionDraft({ owningCompanyId: this.owningCompanyId, sourceType: this.sourceType, sourceId: this.sourceId })
      .subscribe({ next: preview => this.detectedOrderId = preview.existingDrafts?.[0]?.orderId, error: () => undefined });
  }
  open(orderId = this.orderId): void {
    if (!this.permissions.hasPermission(app_permissions.order.records.create) || !this.sourceId || !this.owningCompanyId) return;
    this.launcher.open({ sourceType: this.sourceType, sourceId: this.sourceId, owningCompanyId: this.owningCompanyId,
      sourceLabel: this.sourceLabel, orderId } as ExecutionDraftLaunchData);
  }
  openExisting(): void { if (this.effectiveOrderId) this.router.navigate(['/order/sales-order/edit', this.effectiveOrderId]); }
}
